import classNames from 'classnames'
import Icon from '@components/Icon'

import './styles.scss'

const IconButton = ({
    label,
    icon,
    href,
    className = '',
    disabled,
    isTooltipVisible,
    tooltipText,
    onClick,
    labelLeft,
    onCloseTooltip,
    tooltipClassName,
    ...otherProps
}) => {
    const Element = href ? Link : 'button'
    const to = href ? { to: href } : {}

    return (
        <Element
            {...otherProps}
            {...to}
            disabled={disabled}
            className={classNames('icon-button', {
                [`${className}`]: className,
            })}
            onClick={onClick}>
            {label && labelLeft && <span className="icon-button__text">{label}</span>}
            <Icon className="icon-button__icon" type={icon} />
            {label && !labelLeft && <span className="icon-button__text">{label}</span>}
            {isTooltipVisible ? (
                <div className={classNames('icon-button__tooltip', tooltipClassName)} onClick={onCloseTooltip}>
                    <span>{tooltipText}</span>
                    <Icon className="icon-button__tooltip-icon" type="close" />
                </div>
            ) : null}
        </Element>
    )
}

IconButton.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    icon: PropTypes.string,
    href: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    tooltipText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
}

export default IconButton
